import React, { useState } from 'react';

const CodeBlock = ({ filename, code, language = 'json' }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <div className="bg-dark-surface border border-dark-border rounded-xl overflow-hidden">
      <div className="flex items-center justify-between px-4 py-3 border-b border-dark-border bg-dark-tertiary">
        <span className="text-[13px] text-zinc-500">{filename}</span>
        <button
          onClick={handleCopy}
          className="text-zinc-600 hover:text-zinc-400 text-xs transition-colors"
        >
          {copied ? 'Copied!' : 'Copy'}
        </button>
      </div>
      <pre className="p-5 text-[13px] leading-relaxed text-zinc-200 overflow-x-auto font-mono">
        {code}
      </pre>
    </div>
  );
};

export default CodeBlock;
